exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.check {\n\tmargin-top: 2.6em;\n\tmargin-left: 1em;\n}\n.custom-historico {\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 0.4rem 2rem 2rem;\n}\n.show-plus {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n.tables th,\n.tables td {\n\tborder: none;\n}\n.tables tr:nth-child(even) {\n\tbackground-color: rgba(0, 0, 0, 0.05);\n}\n.tables th {\n\tbackground-color: #1c869a;\n\tcolor: white;\n\tpadding: 8px;\n\tborder: groove 1px lightgray\n}\n", ""]);

// exports
